t = require('views/internal/teacup-with-helpers')('header_info_menu')
socialUrls = require('locale').social

module.exports = t.renderable (key, href, metapagename) ->
  t.li '.meta-link-list-item', ->
    t.a Object.assign({
        class: 'meta-link-list-item-link js-meta-page-link'
      }, {
        href,
        'data-metapagename': metapagename?,
        target: if href then '_blank'
      })
    , t.l(key)



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_info_link.coffee